import { SiteSchedule } from '@hakimo-ui/hakimo/types';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { getScheduleLabels } from '../../sop-workflow/scheduleUtils';

interface Props {
  schedules: SiteSchedule[];
  className?: string;
}

export function ScheduleLabels({ schedules, className }: Props) {
  const labels = getScheduleLabels(schedules ?? []);

  if (!labels.length) return null;

  return (
    <div className={clsx('flex flex-wrap gap-1', className)}>
      {labels.map((label, i) => (
        <div
          key={i}
          className="border-onlight-line-3 dark:border-ondark-line-3 inline-flex items-center gap-1 rounded-full border px-2 py-0.5"
        >
          <CalendarDaysIcon className="text-onlight-text-2 dark:text-ondark-text-2 h-3 w-3 shrink-0" />
          <span className="text-onlight-text-2 dark:text-ondark-text-2 whitespace-nowrap text-xs">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
}

export default ScheduleLabels;
